import PropTypes from "prop-types";
import "./HomeGridItemsSkeleton.css";

export const HomeGridItemsSkeleton = ({ count = 6 }) => {
  return (
    <div className="home-grid-container">
      <div className="home-grid">
        {Array.from({ length: count }).map((_, index) => (
          <div key={index} className="skeleton-module-card">
            <div className="skeleton-module-content">
              <div className="skeleton-icon shimmer"></div>
              <div className="skeleton-divider"></div>
              <div className="skeleton-text-container">
                <div className="skeleton-text shimmer"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

HomeGridItemsSkeleton.propTypes = {
  count: PropTypes.number,
};
